if(!Constant) {
    var Constant = {
        LAYOUT : {
            RAW: 'raw',
            PRE: 'pre',
            APP: 'app'
        }
    };
}

Constant.ERROR_HEADER = {
    CODE: 'errorCode'
};
